// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CkPy","newExpiryDate":"styles_newExpiryDate__wBD87","footer":"styles_footer__34LE4"};